import { render, staticRenderFns } from "./ChannelGroups.vue?vue&type=template&id=ffae3170&"
import script from "./ChannelGroups.vue?vue&type=script&lang=js&"
export * from "./ChannelGroups.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports